// extracted by mini-css-extract-plugin
module.exports = {"container":"HowToPage_container__16sC7","col":"HowToPage_col__1ZksK","emailCard":"HowToPage_emailCard__3-50J"};